// extracted by mini-css-extract-plugin
export default {"link":"style_link__PUaL5","disabled":"style_disabled__W4hM7","s":"style_s__nxhNs","m":"style_m__9w1hx","l":"style_l__xhN2v"};